import { render } from "./Gallery.vue?vue&type=template&id=91d9cbc8&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=91d9cbc8&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d9cbc8"]])

export default __exports__